module.exports = __webpack_public_path__ + "static/media/pdf.a8f44c29.jpg";